import { FC } from 'react';
import styles from './index.module.less';
import { useTrans } from 'base/utils/i18n';

type IOptionTipProps = {
    code: string;
};

export const OptionLabel: FC<IOptionTipProps> = props => {
    const { code } = props;
    const { t } = useTrans();

    return (
        <div className={styles['option-label']}>{t(code)}</div>
    )
};
